module.exports = __webpack_public_path__ + "img/ic_star_black.b7d576db.svg";